import { __, curry } from "ramda";

export let tcDialog = (window.tcDialog = function (usersConfig) {
  var isFn = function (item) {
    return typeof item === "function";
  };
  var on = curry(function ($$, container, eventName, callback, target) {
    $(container).on(eventName, target, callback);
  });

  var off = curry(function ($$, container) {
    return function () {
      $(container).off();
      return container;
    };
  });

  var identity2 = curry(function (a1, a2) {});

  var defaultConfig = {
    $: null,
    showClose: true,
    target: "body",
    container: ".tc-dialog",
    body: ".tc-dialog--body",
    _templateCompiler: function () {
      return Handlebars.compile;
    },
    templateId: "",
    construct: identity2,
    destruct: identity2,
    render: function ($$, data) {
      var source = $("#" + $$.templateId).html();
      var template = $$._templateCompiler()(source);
      return template(data);
    },
    update: function ($$, data) {
      $$.$.find(".tc-dialog--body").empty().append($$.render(data));
    },
    on: on(__, ".tc-dialog"),
    off: off(__, ".tc-dialog"),
  };

  var config = Object.assign({}, defaultConfig, usersConfig);

  for (var methodName in config) {
    if (
      isFn(config[methodName]) &&
      config.hasOwnProperty(methodName) &&
      methodName.indexOf("_") !== 0
    ) {
      config[methodName] = curry(config[methodName])(config);
    }
  }

  function _destruct(config, data) {
    config.off();
    //$(window).off("popstate");
    //location.hash = '';
    var $dialog = config.$.removeClass("tc-dialog").addClass("tc-dialog__hide");
    setTimeout(function () {
      $dialog.remove();
      config.destruct(data);
    }, 400);
  }

  function promiseHandler(config, data) {
    return function (resolve, reject) {
      //history.pushState("tc-dialog", "", "");
      config.resolve = function (res) {
        _destruct(config, data);
        resolve(res);
      };
      config.reject = function (res) {
        _destruct(config, data);
        reject(res);
      };

      config.on(
        "click",
        function () {
          config.reject({
            message: "DIALOG_CANCEL",
          });
        },
        ".tc-dialog--close"
      );

      config.construct(data);
    };
  }

  function _construct(config, data) {
    _render(config, data);
    config.$ = $(config.target).find(".tc-dialog");
    var res = new Promise(promiseHandler(config, data));
    return res;
  }

  function _render(config, data) {
    $(config.target).append(
      "<div class='tc-dialog'>" +
        (config.showClose ? "<i class='tc-dialog--close'></i>" : "") +
        "<div class='tc-dialog--body'>" +
        config.render(data) +
        "</div>" +
        "</div>"
    );
  }

  return function (data) {
    return _construct(config, data);
  };
});
